<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { InformationCircleIcon } from '@heroicons/vue/24/outline'

const route = useRoute()

const { userId } = useCustomAuth({
  autoLoadEnvironments: false,
  debugEnvironments: false,
})

const hasInvitationTicket = computed(() => Boolean(route.query.__clerk_ticket))

definePageMeta({
  layout: 'auth',
})

const { isLoading: isNuxtLoading } = useLoadingIndicator()

const showLoadingSkeleton = computed(
  () => Boolean(userId.value) || isNuxtLoading.value
)

const config = useRuntimeConfig()
useHead({
  title: `${config.public.titleApp} | Iniciar sesión`
})
</script>
<template>
  <div>
    <div>
      <img class="w-auto h-20 mx-auto" src="~/assets/logo.svg" alt="Rem Tools" />
    </div>

    <!-- Invitation notice banner -->
    <div v-if="hasInvitationTicket" class="mt-4 max-w-md mx-auto">
      <div class="rounded-md bg-blue-50 p-4">
        <div class="flex">
          <div class="flex-shrink-0">
            <InformationCircleIcon class="h-5 w-5 text-blue-400" />
          </div>
          <div class="ml-3 flex-1">
            <p class="text-sm text-blue-700">
              Tienes una invitación pendiente. Inicia sesión para aceptarla y unirte a la organización.
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-8 min-h-96">
      <ClerkLoading>
        <SkeletonSignIn />
      </ClerkLoading>

      <!-- <SkeletonSignIn v-if="userId" /> -->
       <SkeletonSignIn v-if="showLoadingSkeleton" />

      <SignIn
        routing="hash"
        force-redirect-url="/welcome"
        fallback-redirect-url="/welcome"
        :appearance="{
          elements: {
            rootBox: 'mx-auto',
            logoBox: 'hidden',
            logoImage: 'hidden'
          }
        }"
      />
    </div>
  </div>
</template>
